import { Pipe, PipeTransform } from '@angular/core';

/**
 * Custom pipe to format dates without timezone conversion
 * This ensures that the displayed date/time matches exactly what was stored in the backend
 * Handles both Date objects and ISO strings
 */
@Pipe({
  name: 'preserveTime',
  standalone: true
})
export class PreserveTimePipe implements PipeTransform {
  transform(value: any): string {
    if (!value) {
      return '';
    }

    try {
      // Handle Date objects directly (which is what we're receiving from Angular)
      if (value instanceof Date) {
        // Verwende direkt die lokalen Komponenten des Date-Objekts
        // Dies entspricht dem, was in der Datenbank gespeichert ist
        const day = value.getDate().toString().padStart(2, '0');
        const month = (value.getMonth() + 1).toString().padStart(2, '0');
        const year = value.getFullYear();
        const hours = value.getHours().toString().padStart(2, '0');
        const minutes = value.getMinutes().toString().padStart(2, '0');
        
        
        return `${day}.${month}.${year} ${hours}:${minutes}`;
      }
      
      // If it's a string, try to parse it as an ISO string
      const dateString = String(value);
      
      // Check if it's an ISO string (2025-06-30T10:00 or 2025-07-05T11:00:00.000Z)
      if (dateString.includes('T')) {
        const [datePart, timePart] = dateString.split('T');
        if (datePart && timePart) {
          const [yearStr, monthStr, dayStr] = datePart.split('-');
          
          // Handle different time formats
          let hourStr = '00';
          let minuteStr = '00';
          
          if (timePart.includes(':')) {
            const timeParts = timePart.split(':');
            hourStr = timeParts[0];
            minuteStr = timeParts[1] || '00';
          }
          
          if (yearStr && monthStr && dayStr) {
            return `${dayStr}.${monthStr}.${yearStr} ${hourStr}:${minuteStr.substring(0, 2)}`;
          }
        }
      }
      
      // If we can't parse it in a special way, return the original
      return dateString;
    } catch (error) {
      console.error('Error formatting date:', error);
      return String(value); // Return original on error
    }
  }
}
